import { render, staticRenderFns } from "./SuZhou.vue?vue&type=template&id=840612ee&scoped=true&"
import script from "./SuZhou.vue?vue&type=script&lang=js&"
export * from "./SuZhou.vue?vue&type=script&lang=js&"
import style0 from "./SuZhou.vue?vue&type=style&index=0&id=840612ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840612ee",
  null
  
)

export default component.exports